/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_CookiesInputs */

const en_analytics_cookies = /** @type {(inputs: Analytics_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const es_analytics_cookies = /** @type {(inputs: Analytics_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analítica`)
};

const fr_analytics_cookies = /** @type {(inputs: Analytics_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Analytics_CookiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const analytics_cookies = /** @type {((inputs?: Analytics_CookiesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_CookiesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_analytics_cookies(inputs)
	if (locale === "es") return es_analytics_cookies(inputs)
	return fr_analytics_cookies(inputs)
});